import { sendAmplitudeEvent, sendRequest } from '@html/_common/utils';

export default function TourRadarMembershipPopup(
  events = { open: null, close: null },
) {
  const TEMPLATE_ENDPOINT = '/api/tours/above-fold-templates';
  const SELECTORS = {
    wrapper: '.js-ao-tour-tourradar-membership-popup__overlay',
    trigger: '.js-tourradar-membership__view-benefits',
    closeBtn: '.js-ao-tour-tourradar-membership-popup__close',
  };
  let templateLoading = false;
  let templateLoaded = false;

  const togglePopup = (toggle) => {
    $('body').toggleClass('layer', toggle);
    $('html').toggleClass('layer', toggle);
    $(SELECTORS.wrapper).toggleClass('hid', !toggle);

    if (toggle) {
      if (events.open) sendAmplitudeEvent(events.open);

      if (!$.magnificPopup) return;

      $.magnificPopup.close();
    }
  };

  const loadPopup = () => {
    templateLoading = true;
    sendRequest?.(
      TEMPLATE_ENDPOINT,
      { action: 'tourradar-membership/tourradar-membership-popup', type: 'read-only' },
      (data) => {
        templateLoading = false;
        if (!data.success) return;

        templateLoaded = true;
        $('body').append(data.component);
        togglePopup(true);
        $(SELECTORS.closeBtn).on('click', () => {
          togglePopup(false);

          if (events.close) sendAmplitudeEvent(events.close);
        });
      },
      {},
      () => {
        templateLoading = false;
        templateLoaded = false;
      },
    );
  };

  const initiate = () => {
    $(SELECTORS.trigger).on('click', () => {
      if (templateLoading) return false;
      if (!templateLoaded) return loadPopup();

      togglePopup(true);
      return true;
    });
  };

  return { initiate };
}
